import { render, staticRenderFns } from "./AppStoreDiscoverSection.vue?vue&type=template&id=32ad4b6a&scoped=true"
import script from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreDiscoverSection.vue?vue&type=style&index=0&id=32ad4b6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad4b6a",
  null
  
)

export default component.exports